import storage from 'didi-store'
import { isString, isNumber } from 'lodash-es'

export default {
  async updateLogin (state, data) {
    state.login = data
    // 向端透传用户信息
    if (window.SodaBD.configUserInfo) {
      let userInfo = data.userInfo
      userInfo.token = storage.get('ticket')
      delete userInfo.feature_auth
      window.SodaBD.configUserInfo(userInfo, function () {})
    }
  },
  updateGeo (state, data) {
    state.geo = data
  },
  updateAreaGroup (state, data) {
    state.areaGroup = data
  },
  updateAreaSelections (state, data) {
    state.areaSelections = data
  },
  updateSummary (state, data) {
    state.summary = data
  },
  updateTaskIndexList (state, data) {
    state.taskIndexList = data
  },
  updateTaskIndex (state, data) {
    state.taskIndex = data
  },
  updateOnboardingIndex (state, data) {
    state.onboardingIndex = data
  },
  updateEngagementIndex (state, data) {
    state.engagementIndex = data
  },
  updateCountByStatus (state, data) {
    state.countByStatus = data
  },
  updateManualChangedAreaGroup (state, data) {
    state.manualChangedAreaGroup = data
  },
  updateRouterQueue (state, data) {
    state.routerQueue = data
  },
  updateIsRefreshHomeList (state, data) {
    state.isRefreshHomeList = data
  },
  updateIsRefreshHomeListAll (state, data) {
    state.isRefreshHomeListAll = data
  },
  updateIsRefreshHomeListPriority (state, data) {
    state.isRefreshHomeListPriority = data
  },
  updateIsRefreshTaskList (state, data) {
    state.isRefreshTaskList = data
  },
  updateVajraListData (state, data) {
    state.vajraListData = data
  },
  updateTagIds (state, data) {
    state.tagIds = data
  },
  updateServiceCity (state, data) {
    state.serviceCity = data
  },
  toggleLoading (state, count) {
    state.global.loading += count
  },
  goto (state, path) {
    if (isString(path) || isNumber(path)) {
      path = {
        path,
        delay: 0
      }
    }
    state.global.jumpPath = { ...path }
  },
  message (state, message) {
    const defaults = {
      txt: '',
      time: 1000,
      type: 'correct'
    }
    if (isString(message)) {
      message = {txt: message}
    }
    state.global.message = { ...defaults, ...message }
  },
  setShopCommonConfig (state, payload) {
    state.shopCommonConfig = payload
  },
  setUserAuthCountry (state, payload) {
    let resultArr = []
    payload.forEach((item, index) => {
      let obj = {}
      obj = item
      obj.text = item.label
      obj.index = index
      item.children.forEach((i, x) => {
        obj.children[x].text = i.label
      })
      item.locale.forEach((i, x) => {
        obj.locale[x].text = i.label
      })
      resultArr.push(obj)
      state.countryMapLangConf[item.value] = item.locale
    })
    state.countryConfig = resultArr
  },
  setInWhiteList (state, payload) {
    state.inWhiteList = payload
  }

}
